import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import CirculationConfig from '../../config/CirculationConfig';

/**
 * 表頭Menu
 * */
function HeaderMenu(props) {

    var view = {
        menu: function () {
            var view_data = [];
            var items = CirculationConfig.SitemapConfig;
            var menus = items.menu;

            menus.map((p) => {

                if (p.name !== '機構業者' && p.name !== '一般民眾') {
                    if (p.items != null && p.items.length > 0) {
                        //先給頭
                        view_data.push(<>
                            <div className="cp dropdown-toggle" title={p.name} type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                {p.name}
                            </div>
                            <ul className="dropdown-menu">
                                {
                                    p.items.map((c) => {
                                        if (c.to != null)
                                            return (<li><Link className="dropdown-item" title={c.name} to={c.to} >{c.name}</Link></li>);
                                        if (c.href != null)
                                            return (<li><a className="dropdown-item" title={c.name} rel="noopener noreferrer" target="_blank" href={c.href} >{c.name}</a></li>);
                                    })
                                }
                            </ul>
                        </>);
                    } else {
                        //如果沒有子選項
                        if (p.to != null) {
                            view_data.push(
                                <div className="cp" title={p.name} type="button">
                                    <Link className="cp hyper" title={p.name} to={p.to}>{p.name}</Link>
                                </div>
                            );
                        } else {
                            view_data.push(
                                <div className="cp" title={p.name} type="button">
                                    <a className="cp hyper" title={p.name} rel="noopener noreferrer" target="_blank" href={p.href}>{p.name}</a>
                                </div>
                            );
                        }
                    }
                }

            })


            return (view_data);
        }

    }

    return (<>{view.menu()}</>)
}

function FooterMenu(props) {

    var view = {

        menu: function () {
            var view_data = [];
            var items = CirculationConfig.SitemapConfig;
            var menus = items.menu;
            menus.map((p) => {
                if (p.items != null && p.items.length > 0) {
                    view_data.push(
                        <div className="itemBox col-lg-2 col-md-4 col-sm-6 col-12">
                            <div className="title">{p.name}</div>
                            {
                                p.items.map((c) => {
                                    if (c.to != null) {
                                        return (<div className="item"><Link className="dropdown-item" title={c.name} to={c.to}>{c.name}</Link></div>)
                                    }
                                    if (c.href != null) {
                                        return (<div className="item"><a rel="noopener noreferrer" target="_blank" className="dropdown-item" title={c.name +"(另開視窗)"} href={c.href}>{c.name}</a></div>)
                                    }
                                })
                            }
                        </div>);
                } else {
                    if (p.to != null) {
                        view_data.push(
                            <div className="itemBox col-lg-2 col-md-4 col-sm-6 col-12">
                                <div className="title">{p.name}</div>
                                <div className="item"><Link className="dropdown-item" title={p.name} to={p.to}>{p.name}</Link></div>
                            </div>);
                    }
                    if (p.href != null) {
                        view_data.push(
                            <div className="itemBox col-lg-2 col-md-4 col-sm-6 col-12">
                                <div className="title">{p.name}</div>
                                <div className="item"><a className="dropdown-item" title={p.name +"(另開視窗)"} href={p.href} target="_blank" className="dropdown-item">{p.name}</a></div>
                            </div>);
                    }
                }
            });

            return (view_data);
        }
    }

    return (<>{view.menu()}</>);
}

function SiteMapMenu(props) {
    var view = {

        menu: function () {
            var view_data = [];
            var items = CirculationConfig.SitemapConfig;
            var menus = items.menu;
            menus.map((p, index) => {
                var p_index = index + 1;
                if (p.items != null && p.items.length > 0) {
                    view_data.push(<div className="col-12 col-sm-6 col-md-4">
                        <ul className="tourUl">
                            <li>{p_index + '. ' + p.name}</li>
                            <ul>
                                {
                                    p.items.map((c,c_index) => {
                                        var name = p_index + '.' + (c_index + 1) + ' ' + c.name;
                                        var to = c.to;
                                        var href = c.href;
                                        if (to!=null)
                                            return (<li><Link className="alinkclear" to={to} title={name}>{name}</Link></li>)

                                        if (href != null) {
                                            name = name;
                                            return (<li><a className="alinkclear" title={name + "(另開視窗)"} rel="noopener noreferrer" target="_blank" href={href}>{name}</a></li>)
                                        }
                                    })
                                }
                            </ul>
                        </ul>
                    </div>)
                } else {
                    var name = p_index + '.1 ' + p.name;
                    var to = p.to;
                    var href = p.href;
                    var html = <li><Link className="alinkclear" to={to} title={name}>{name}</Link></li>;
                    if (to == null) {
                        html = <li><a className="alinkclear" title={name + "(另開視窗)"} rel="noopener noreferrer" target="_blank" href={href}>{name}</a></li>;
                    }
                    view_data.push(<div className="col-12 col-sm-6 col-md-4">
                        <ul className="tourUl">
                            <li>{p_index + '. ' + p.name}</li>
                            <ul>
                            {html}
                           </ul>
                        </ul>
                    </div>);
                    
                }
            });
            return (view_data);
        }
    }

    return (<>{view.menu()}</>);
}

/**
 * 行動裝置顯示
 * @param {any} props
 */
function MobileMenu(props) {

    var view = {
        menu: function () {
            var view_data = [];
            var items = CirculationConfig.SitemapConfig;
            var menus = items.menu;

            menus.map((p,index) => {

                
                var id = "collaps" + index;
                var heading = 'heading' + id;
                if (p.items != null && p.items.length > 0) {
                    //先給頭
                    view_data.push(
                        <div className="accordion-item">
                            <h2 className="accordion-header" id={heading} >
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target={'#' + id} aria-expanded="false" aria-controls={id} >
                                    {p.name}
                                </button>
                            </h2>

                            <div id={id} className="accordion-collapse collapse" aria-labelledby={heading}
                                data-bs-parent="#accordionExample">
                                {
                                    p.items.map((c) => {
                                        if (c.to != null)
                                            return (<div className="item"><Link className="dropdown-item" title={c.name} to={c.to} >{c.name}</Link></div>);
                                        if (c.href != null)
                                            return (<div className="item"><a className="dropdown-item" title={c.name} rel="noopener noreferrer" target="_blank" href={c.href} >{c.name}</a></div>);
                                    })
                                }
                            </div>
                        </div>);
                } else {
                    //如果沒有子選項

                    var name = p.name;
                    var to = p.to;
                    var href = p.href;
                    var html = <div className="item"><Link className="dropdown-item" title={name} to={to} >{name}</Link></div>;
                    if (to == null) {
                        html = <div className="item"><a className="dropdown-item" title={name + "(另開視窗)"} rel="noopener noreferrer" target="_blank" href={href}>{name}</a></div>;
                    }

                    view_data.push(
                        <div className="accordion-item">
                            <h2 className="accordion-header" id={heading}>
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                    data-bs-target={'#' + id} aria-expanded="false" aria-controls={id}>
                                    {p.name}
                                </button>
                            </h2>
                            <div id={id} className="accordion-collapse collapse" aria-labelledby={heading}
                                data-bs-parent="#accordionExample">
                                {html}
                            </div>
                        </div>);

                }

            })


            return (view_data);
        }

    }

    return (<>{view.menu()}</>)
}

export { HeaderMenu, FooterMenu, SiteMapMenu, MobileMenu }